module.exports = __webpack_public_path__ + "static/media/Artboard1.626f8be2.png";